module.exports = __webpack_public_path__ + "static/media/t1-img2.c5d6a0f9.png";